<template>
    <div>
        <label for="teamName">Team Name:</label>
        <input id="teamName" type="string" v-model="props.team.teamName" />
    </div>
    <div>
        <label for="description">Description:</label>
        <textarea class="description" id="description" v-model="props.team.description"></textarea>
    </div>
    <div>
        <label for="i_serviceId">Service</label>
        <vue-select id="i_serviceId" label="blServiceName" :options="getItems()" :clearable="false"
            :reduce="(item: ServiceItem) => item.id" v-model="props.team.service.id"/>
    </div>
</template>


<script lang="ts" setup>
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import VueSelect from "vue-select";
import { ServiceItem } from '@/services/entities/ServiceItem';
import { useSettingsStore } from '@/stores/setting';

const settingsStore = useSettingsStore();

const props = defineProps({
    team: { Type: {} as ServiceTeamItem, required: true, default: () => ({} as ServiceTeamItem) },
});

function getItems() {
    return settingsStore.getServices.filter(s => s.isActive)
}

</script>
<style scoped lang="scss">
.description { 
    width: 100%; 
    min-height: 50px; 
    max-height: 100px; 
    resize: vertical; 
    padding: .5rem; 
    font-size: 14px; 
    font-style: italic;
    box-sizing: border-box; 
}
</style>